import React, { useEffect, useState } from "react";
import { Button, Col, Input, Row, Table } from "reactstrap";
import _ from "lodash";
import { useParams, useNavigate } from "react-router-dom";
import { api, constants, dateHelpers, helpers } from "../utils";
import { DesktopContainer } from "../layouts";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";
import ServiceThreadSpinner from "./ServiceThreadSpinner";
import { confirmAlert } from "react-confirm-alert";
import classNames from "classnames";

export default function WorkOrderDetail(props) {
   const navigate = useNavigate();
   const { workOrderId } = useParams();
   const [isLoading, setIsLoading] = useState(false);
   const [printers, setPrinters] = useState([]);
   const [printToPrinter, setPrintToPrinter] = useState(true);
   const [selectedPrinter, setSelectedPrinter] = useState(null);
   const [workOrder, setWorkOrder] = useState(null);

   useEffect(() => {
      const cancelToken = axios.CancelToken;
      const source = cancelToken.source();
      getPrinters();
      if (!_.isNil(workOrderId)) {
         let id = null;
         if (typeof workOrderId === "string") {
            id = parseInt(workOrderId);
            if (_.isNaN(workOrderId) || _.isNil(workOrderId)) {
               toast.error("workOrder Id was not formatted correctly, refresh this page and try again...");
               return;
            }
         } else {
            id = workOrderId;
         }
         api
            .fetchS(`Quality/GetWorkOrderById/${id}`, {}, source.token)
            .then((r) => {
               if (!r.data.success) {
                  if (r.data.message) {
                     toast.error(r.data.message);
                  } else {
                     toast.error("critical error has occured please contact your admin...");
                  }
               }
               if (r.data.success) {
                  setWorkOrder(r.data.workOrder);
               }
            })
            .catch(api.catchHandler)
      }
      return () => {
         source.cancel("axios request cancelled");
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   const cancelCase = (barcodeId) => {
      api
         .fetch(`Quality/CancelWorkOrderCase/${barcodeId}`)
         .then((r) => {
            if (!r.data.success) {
               if (r.data.message) {
                  toast.error(r.data.message);
               } else {
                  toast.error("critical error has occured please contact your admin...");
               }
            }
            if (r.data.success) {
               let id = null;
               if (typeof workOrderId === "string") {
                  id = parseInt(workOrderId);
                  if (_.isNaN(workOrderId) || _.isNil(workOrderId)) {
                     toast.error("workOrder Id was not formatted correctly, refresh this page and try again...");
                     return;
                  }
               } else {
                  id = workOrderId;
               }
               api
                  .fetch(`Quality/GetWorkOrderById/${id}`)
                  .then((r) => {
                     if (!r.data.success) {
                        if (r.data.message) {
                           toast.error(r.data.message);
                        } else {
                           toast.error("critical error has occured please contact your admin...");
                        }
                     }
                     if (r.data.success) {
                        setWorkOrder(r.data.workOrder);
                     }
                  })
                  .catch(api.catchHandler);
               toast.success(r.data.message);
            }
         })
         .catch(api.catchHandler);
   };

   function formatPrinters(data) {
      let printerArr = _.concat(data.labels, data.lasers, data.parts);
      let list = _.map(printerArr, (x) => {
         return { label: x.nameOnly, value: x.id };
      });
      return list.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : ((b.label.toLowerCase() > a.label.toLowerCase()) ? -1 : 0));
   }

   function getPrinters() {
      api
         .fetch("Printer/GetPrintersForDropdown")
         .then((response) => {
            if (response) {
               setPrinters(formatPrinters(response.data));
            } else {
               toast.error("Failed to get printers.");
            }
         })
         .catch(api.catchHandler);
   }

   function handleCancelWorkOrder() {
      confirmAlert({
         title: "Cancel Order",
         message: "Are you sure you want to cancel this work order?",
         buttons: [
            { label: "Yes", onClick: handleCancelWorkOrderFinal, },
            { label: "No", },
         ],
      });
   }

   function handleCancelWorkOrderFinal() {
      api
         .fetch(`Production/CancelWorkOrder/${workOrder.workOrderId}`)
         .then((r) => {
            if (r.data.success) {
               toast.success("Successfully canceled the work order, navigating back to production work order screen..");
               setIsLoading(true);
               setTimeout(() => {
                  navigate(constants.ENDPOINTS.productionWorkOrders);
                  //in 3 seconds
               }, 3000)

            } else {
               toast.error(r.data.message);
            }
         })
         .catch(api.catchHandler)
         .finally(() => { });
   }

   function handleReprintLabels() {
      confirmAlert({
         title: "Reprint Labels",
         message: `Are you sure you want to reprint the production labels for this work order? 
          Doing so will cause any existing production labels to become invalid.`,
         buttons: [
            { label: "Yes", onClick: handleReprintLabelFinal, },
            { label: "No", },
         ],
      });
   }

   function handleReprintLabelFinal() {
      let payload = {
         WorkOrderId: workOrder.workOrderId,
         PrinterName: helpers.valuelabelFromSelect(selectedPrinter),
         PrinterId: helpers.valueFromSelect(selectedPrinter),
         PrintToPrinter: printToPrinter
      }

      if (_.isNil(payload.PrinterName) || payload.PrinterName === "" || !payload.PrinterName) {
         toast.error("please select a printer before proceeding...");
         return;
      }

      if (printToPrinter) {
         api
            .post(`Production/ReprintAllLabels`, payload)
            .then((res) => {
               if (res.data?.success === false) {
                  toast.error(res.data.message);
               } else {
                  toast.success("Labels Printed");
               }
            })
            .catch((error) => {
               api.catchHandler(error);
            });
      } else {
         api
            .postDownloadBinary(
               `Production/ReprintAllLabels`,
               payload,
               constants.MIME_TYPES.pdf,
               `WO_Labels_${dateHelpers.monthDayAndYear(Date.now())}.pdf`,
               "There was an error downloading the labels, contact your admin."
            )
            .then((res) => {
               if (res?.data === false) {
                  toast.error(res.message);
               } else {
                  toast.success("Labels Printed");
               }
            })
            .catch((error) => {
               api.catchHandler(error);
            });
      }
   }

   const reprintLabel = (barcodeId) => {
      let payload = {
         BarCodeId: barcodeId,
         PrinterName: helpers.valuelabelFromSelect(selectedPrinter),
         PrinterId: helpers.valueFromSelect(selectedPrinter),
         PrintToPrinter: printToPrinter
      };

      if (_.isNil(payload.PrinterName) || payload.PrinterName === "" || !payload.PrinterName) {
         toast.error("please select a printer before proceeding...");
         return;
      }
      if (printToPrinter) {
         api
            .post(`Quality/ReprintLabel`, payload,)
            .then((res) => {
               if (res.data?.success === false) {
                  toast.error(res.data.message);
               } else {
                  toast.success("Label Printed");
               }
            })
            .catch((error) => {
               api.catchHandler(error);
            });
      } else {
         api
            .postDownloadBinary(
               `Quality/ReprintLabel`,
               payload,
               constants.MIME_TYPES.pdf,
               `WO_Label_${dateHelpers.monthDayAndYear(Date.now())}.pdf`,
               "There was an error downloading the labels, contact your admin."
            )
            .then((res) => {
               if (res?.data === false) {
                  toast.error(res.message);
               } else {
                  toast.success("Label Printed");
               }
            })
            .catch((error) => {
               api.catchHandler(error);
            });
      }
   };


   return (
      <DesktopContainer screenName={"Work Order Detail"}>
         <ServiceThreadSpinner on={_.isNil(workOrder) || isLoading}>
            {workOrder && (
               <div className="filter-header mb-3">
                  <Row>
                     <Col xxl="3" style={{ textAlign: "right", marginRight: "5px" }}>
                        <h5 children="Work Order #:" className="float-end text-white" />
                     </Col>
                     <Col>
                        <h5
                           children={workOrder.displayId}
                           className="float-start text-white"
                        />
                     </Col>
                  </Row>

                  <Row>
                     <Col xxl="3" style={{ textAlign: "right", marginRight: "5px" }}>
                        <h5 children="Status:" className="float-end text-white" />
                     </Col>
                     <Col>
                        <h5
                           children={workOrder.status}
                           className="float-start text-white"
                        />
                     </Col>
                  </Row>

                  <Row>
                     <Col xxl="3" style={{ textAlign: "right", marginRight: "5px" }}>
                        <h5 children="Item Number:" className="float-end text-white" />
                     </Col>
                     <Col>
                        <h5
                           children={workOrder.itemWithDesc}
                           className="float-start text-white"
                        />
                     </Col>
                  </Row>

                  <Row>
                     <Col xxl="3" style={{ textAlign: "right", marginRight: "5px" }}>
                        <h5 children="Total Cases:" className="float-end text-white" />
                     </Col>
                     <Col>
                        <h5
                           children={workOrder.casesToProduce}
                           className="float-start text-white"
                        />
                     </Col>
                  </Row>

                  <Row>
                     <Col xxl="3" style={{ textAlign: "right", marginRight: "5px" }}>
                        <h5 children="Created Date:" className="float-end text-white" />
                     </Col>
                     <Col>
                        <h5
                           children={dateHelpers.toLongDateString(workOrder.createdDate)}
                           className="float-start text-white"
                        />
                     </Col>
                  </Row>

                  <Row>
                     <Col xxl="3" style={{ textAlign: "right", marginRight: "5px" }}>
                        <h5
                           children="Completed Date:"
                           className="float-end text-white"
                        />
                     </Col>
                     <Col>
                        <h5
                           children={
                              Date.parse(workOrder.completedDate) === -62135579038000
                                 ? "N/A"
                                 : dateHelpers.toLongDateString(workOrder.completedDate)
                           }
                           className="float-start text-white"
                        />
                     </Col>
                  </Row>

                  <hr />
                  <Row>
                     <Col className={"text-center"} style={{ color: "white" }}>
                        <h4>Work Order Cases</h4>
                     </Col>
                  </Row>

                  <Row>
                     <Col xxl="3" style={{ textAlign: "right", marginRight: "5px", paddingTop: "5px", }} >
                        <h5
                           children="Select Printer:"
                           className="float-end text-white"
                        />
                     </Col>
                     <Col xxl="4">
                        <Select
                           classNamePrefix="serviceThreadSelect"
                           options={printers}
                           value={selectedPrinter}
                           onChange={(e) => setSelectedPrinter(e)}
                           isMulti={false}
                           isClearable={false}
                        />
                     </Col>
                     <Col xxl="2" className="text-white pt-2">
                        <Input
                           className="mx-2"
                           type="checkbox"
                           defaultChecked={true}
                           value={printToPrinter}
                           options={printers}
                           onChange={(e) => setPrintToPrinter(e.target.checked)}
                        />
                        &nbsp;Print to Printer?
                     </Col>
                  </Row>
                  <hr />

                  <Row>
                     <Col xxl={{ offset: 2, size: 9 }}>
                        {_.isEmpty(workOrder.cases) ? (
                           <h5
                              children={"No Cases were found for this work order"}
                              className="float-start text-white"
                           />
                        ) : (
                           <Table size="sm" className="data-table">
                              <thead className="table-header">
                                 <tr>
                                    <th children={"Case Barcode"} />
                                    <th children={"Lot Number"} />
                                    <th children={"Status"} />
                                    <th children={"Production Date"} />
                                    <th children={"Fullfilled Date"} />
                                    <th children={"Disassembled Date"} />
                                    <th children={"Case Id"} />
                                    <th children={"Gross Weight"} />
                                    <th children={""} />
                                    <th children={""} />
                                 </tr>
                              </thead>
                              <tbody>
                                 {_.map(workOrder.cases, (x, index) => {
                                    return (
                                       <tr key={index}
                                          className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}
                                       >
                                          <td className="data-cell" children={x.barcodeId} />
                                          <td className="data-cell" children={x.lotNumber} />
                                          <td className="data-cell" children={x.caseStatus} />
                                          <td className="data-cell" children={x.productionDate} />
                                          <td className="data-cell" children={x.fulfilledDate} />
                                          <td className="data-cell" children={x.disassembledDate} />
                                          <td className="data-cell" children={x.caseId} />
                                          <td className="data-cell" children={x.grossWeight} />
                                          <td className="data-cell">
                                             {x.caseStatusId === 2 ? (
                                                <h6
                                                   className="shredLink"
                                                   onClick={() => reprintLabel(x.barcodeId)}
                                                >
                                                   Reprint Case Label
                                                </h6>
                                             ) : (
                                                "NA"
                                             )}
                                          </td>
                                          <td className="data-cell">
                                             {x.caseStatusId === 2 ? (
                                                <h6
                                                   className="shredLink"
                                                   onClick={() => cancelCase(x.barcodeId)}
                                                >
                                                   Cancel Case
                                                </h6>
                                             ) : (
                                                "NA"
                                             )}
                                          </td>
                                       </tr>
                                    );
                                 })}
                              </tbody>
                           </Table>
                        )}
                     </Col>
                  </Row>

                  <Row className="mt-3">
                     <Col xxl="2" />
                     <Col>
                        <Button
                           className="shredButton"
                           style={{ marginRight: "15px" }}
                           onClick={() => handleReprintLabels()}
                        >
                           Reprint All Labels
                        </Button>
                        <Button
                           className={classNames("shredButton", { "d-none": workOrder.statusId !== 1 })}
                           onClick={() => handleCancelWorkOrder()}
                        >
                           Cancel Work Order
                        </Button>
                     </Col>
                  </Row>
               </div>
            )}
         </ServiceThreadSpinner>
      </DesktopContainer>
   );
}
